import { linkify } from './linkify';

/** Text with its http(s) URLs as links that open in a new tab. */
export function LinkifiedText({ text }: { text: string }) {
    let offset = 0;
    const parts = linkify(text).map((part) => {
        const key = offset;
        offset += part.text.length;
        return { part, key };
    });
    return (
        <>
            {parts.map(({ part, key }) =>
                part.type === 'link' ? (
                    <a
                        key={key}
                        href={part.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary underline underline-offset-2"
                    >
                        {part.text}
                    </a>
                ) : (
                    <span key={key}>{part.text}</span>
                ),
            )}
        </>
    );
}
